// src/components/Features.jsx
import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./feature.css"; // Optional: your own styles
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Features = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="container mt-5 pt-4 features-section">
      <div className="row justify-content-center">
        <div className="col-lg-2 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
          <div className="feature-box">
            <div className="feature-icon">
          <i class="bi bi-shop"></i>
            </div>
            <h4>Food Delivery</h4>
            
          </div>
        </div>

        <div className="col-lg-2 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
          <div className="feature-box">
            <div className="feature-icon">
              <i class="bi bi-truck"></i>
            </div>
            <h4>Courier Delivery</h4>

          </div>
        </div>

        <div className="col-lg-2 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="400">
          <div className="feature-box">
            <div className="feature-icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>Party Zone</h4>
          
          </div>
        </div>

        <div className="col-lg-2 col-md-6 mb-4 "   data-aos="fade-up" data-aos-delay="500">
          <div className="feature-box">
            <div className="feature-icon">
          <i class="bi bi-fork-knife"></i>
            </div>
            <h4>Catering Zone</h4>
  
          </div>
        </div>
        <div className="col-lg-2 col-md-6 mb-4 "   data-aos="fade-up" data-aos-delay="500">
          <div className="feature-box">
            <div className="feature-icon">
          <i class="bi bi-mailbox"></i>
            </div>
            <h4>Dine Zone</h4>
  
          </div>
        </div>
      </div>

   <div className="services">
      <div className="stats-highlight">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Downlaods</div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="stat-item">
              <div className="stat-number">1+</div>
              <div className="stat-label">No of Vendors</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default Features;
